
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delete-background",
      function () {
        return require("private-next-pages/delete-background/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delete-background"])
      });
    }
  